export const TOS_ATTEMPT = "TOS_ATTEMPT";
export const TOS_SUCCESS = "TOS_SUCCESS";
export const TOS_FAILED = "TOS_FAILED";
